import { useEffect, useMemo, useState } from 'react';
import { getRouter } from '../../getRouter';
import { useMeQuery } from '../../apiHooks/useMeQuery';
import { useAuthStore } from '../../components/Login/useAuthStore';
import { useIsPermittedOrigin } from '../../appState/hooks/useOrigin';

export function useRouter() {
  const location = window.location;
  const otpRequested = useAuthStore((state) => state.loginStatus) === 'otpRequested';
  const loginStatus = useAuthStore((state) => state.loginStatus);

  const [origin, setOrigin] = useState(location.origin);
  useEffect(() => {
    setOrigin(location.origin);
  }, [location.origin]);
  const { data: meData } = useMeQuery();
  const isPermittedOrigin = useIsPermittedOrigin();

  const router = useMemo(() => {
    return getRouter({
      origin,
      otpRequested,
      isManager: meData ? meData.portalRole === 'manager' : undefined,
      loginStatus,
      isPermittedOrigin,
    });
  }, [origin, otpRequested, meData, loginStatus, isPermittedOrigin]);

  return router;
}
